import commonMutations from '@/store/data/common/mutations'
import { findIndex, toNumber } from 'lodash'
import Vue from 'vue'

const mutations = {
    ...commonMutations,

    removeAccountsDsp(state, { id }) {
        const indexOfAccountsDspToRemove = findIndex(state.list, item => toNumber(item.id) === toNumber(id))
        Vue.delete(state.list, indexOfAccountsDspToRemove)
    },

    setUpdatedAccountsDsp(state, { item }) {
        const accountsDspList = state.list
        const _elemIndex = findIndex(accountsDspList, _item => toNumber(item.id) === toNumber(_item.id))
        accountsDspList.splice(_elemIndex, 1, item)

        Vue.set(state, 'list', accountsDspList)
    }
}

export default mutations
